import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import type { ColumnsType } from "antd/es/table";
import Table from "antd/es/table";
import React from "react";
import { useParams } from "react-router-dom";
import { Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useGetBandobastSummaryQuery } from "../../services/appln";
import * as XLSX from "xlsx";

export default function OverviewReport() {
  const params = useParams();

  const [rawData, setRawData] = React.useState<any>([]);

  interface RowInfo {
    timeslotName: string;
    range: number;
    areaCount: number;
    subareaCount: number;
    pointCount: number;
    personnelAssessmentCount: number;
    personnelAllocationCount: number;
  }

  const queryResponse = useGetBandobastSummaryQuery({
    bandobastId: params.bandobastId,
  });

  React.useEffect(() => {
    if (!queryResponse.isSuccess) {
      return;
    }
    setRawData(queryResponse.data.data);
  }, [queryResponse]);

  if (queryResponse.isLoading || queryResponse.isFetching) {
    return (
      <Box sx={{ flexGrow: 1, width: "100%", margin: "20px" }}>
        <Title text={strings.overview}></Title>
        <ProgressIndicator />
      </Box>
    );
  }

  console.log("OverviewReport, rawData", rawData);

  const columns: ColumnsType<RowInfo> = [
    {
      title: strings.name,
      dataIndex: "timeslotName",
      key: "timeslotName",
    },
    {
      title: strings.rangeCount,
      dataIndex: "range",
      key: "range",
    },
    {
      title: strings.areaCount,
      dataIndex: "area",
      key: "area",
    },
    {
      title: strings.subareaCount,
      dataIndex: "subarea",
      key: "subarea",
    },
    {
      title: strings.pointCount,
      dataIndex: "point",
      key: "point",
    },
    {
      title: strings.personnelAssessmentCount,
      dataIndex: "personnelAssessmentCount",
      key: "personnelAssessmentCount",
    },
    {
      title: strings.personnelAllocationCount,
      dataIndex: "personnelAllocationCount",
      key: "personnelAllocationCount",
    },
  ];

  return (
    <div>
      <Box
        sx={{
          height: 400,
          width: "100%",
          marginTop: "10px",
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Title text={strings.overview}></Title>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={() => {
                // console.log("in export handler", rawData);
                const excelData = rawData.map((row: any) => {
                  const output: any = {};
                  output[strings.name] = row["timeslotName"];
                  output[strings.rangeCount] = row["range"];
                  output[strings.areaCount] = row["area"];
                  output[strings.subareaCount] = row["subarea"];
                  output[strings.pointCount] = row["point"];
                  output[strings.personnelAssessmentCount] =
                    row["personnelAssessmentCount"];
                  output[strings.personnelAllocationCount] =
                    row["personnelAllocationCount"];
                  return output;
                });
                // console.log("excelData", excelData);
                const worksheet = XLSX.utils.json_to_sheet(excelData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Summary");
                XLSX.writeFile(workbook, "report.xlsx");
              }}
            >
              {strings.export}
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Table
              scroll={{ y: 300 }}
              columns={columns}
              dataSource={rawData}
              pagination={false}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
